let _pageInfo = null;

const pageInfo = {};

/**
 * Sets the page info
 * @param  {*} val
 */
pageInfo.set = function(val) {
  _pageInfo = val;
};

pageInfo.get = function() {
  return _pageInfo;
};

export default pageInfo;
